
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"10","viewBox":"0 0 8 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.9987 10C3.63051 10 3.33203 9.70152 3.33203 9.33333L3.33203 1.91676C3.33203 1.54857 3.63051 1.25009 3.9987 1.25009C4.36689 1.25009 4.66536 1.54857 4.66536 1.91676L4.66536 9.33333C4.66536 9.70152 4.36689 10 3.9987 10Z","fill":"#4A3428"}}),_c('path',{attrs:{"d":"M7.59587 3.71762C7.82121 3.95059 7.82122 4.32028 7.5959 4.55327C7.35966 4.79753 6.96805 4.79751 6.73184 4.55323L4.71889 2.47148C4.32582 2.06498 3.67418 2.06498 3.28111 2.47148L1.26816 4.55323C1.03195 4.79751 0.640339 4.79753 0.404103 4.55327C0.178776 4.32028 0.17879 3.95059 0.404133 3.71762L3.28124 0.743149C3.67428 0.336808 4.32575 0.336809 4.71879 0.743151L7.59587 3.71762Z","fill":"#4A3428"}})])
          )
        }
      }
    